import { connect } from "react-redux";
import {
    updateLoadingStatus,
    getPlanningData,
    setSelectedCategoryIndex,
    setSlideArray,
    resetSelectedSlide,
    resetReadyAddToCartList,
    updateSamePosition,
    updateGoToRow,
    updateIsSendDesignCode,
    updateShowResultStatus,
    updateShowGetProductionJsonModal,
    updateShowProductionListModal,
    updateShowPostProductionJsonModal,
    updateShowAddToCartProductListModal,
    updateListDataJson,
    postSimpleProductApi,
    postAddToCartApi,
    postSaveStatusApi,
    getSaveStatusApi,
} from "../actions/productPlanningActions";
import Main from "../components/Main";

const mapStateToProps = (state, ownProps) => {
    const {
        isLoading,
        planningData,
        selectedCategoryIndex,
        selectedState,
        isReset,
        isGoToTheSamePosition,
        gotoRow,
        isSendDesignCode,
        isShowResult,
        isShowGetProductionJsonModal,
        isShowProductionListModal,
        isShowPostProductionJsonModal,
        isShowAddToCartProductListModal,
        listData,
        totalAmount,
        simpleProductData,
        readyAddToCartList,
        alreadyAddToCartList,
        addToCartStatus,
        saveJson,
    } = state.planningState;
    return {
        isLoading,
        planningData,
        selectedCategoryIndex,
        selectedState,
        isReset,
        isGoToTheSamePosition,
        gotoRow,
        isSendDesignCode,
        isShowResult,
        isShowGetProductionJsonModal,
        isShowProductionListModal,
        isShowPostProductionJsonModal,
        isShowAddToCartProductListModal,
        listData,
        totalAmount,
        simpleProductData,
        readyAddToCartList, // 等待加入購物車商品
        alreadyAddToCartList, // 已加入購物車商品
        addToCartStatus,
        saveJson,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatch: dispatch,
    updateLoadingStatus: (isLoading) =>
        dispatch(updateLoadingStatus(isLoading)),
    getPlanningData: () => dispatch(getPlanningData()),
    setSelectedCategoryIndex: (selectedCategoryIndex) =>
        dispatch(setSelectedCategoryIndex(selectedCategoryIndex)),
    setSlideArray: (selectedState) => dispatch(setSlideArray(selectedState)),
    resetSelected: (isReset) => dispatch(resetSelectedSlide(isReset)),
    resetReadyAddToCartList: () => dispatch(resetReadyAddToCartList()),
    updateSamePosition: (isGoToTheSamePosition) =>
        dispatch(updateSamePosition(isGoToTheSamePosition)),
    updateGoToRow: (gotoRow) => dispatch(updateGoToRow(gotoRow)),
    updateIsSendDesignCode: (isSendDesignCode) =>
        dispatch(updateIsSendDesignCode(isSendDesignCode)),
    updateShowResultStatus: (isShowResult) =>
        dispatch(updateShowResultStatus(isShowResult)),
    updateShowGetProductionJsonModal: (isShowGetProductionJsonModal) =>
        dispatch(
            updateShowGetProductionJsonModal(isShowGetProductionJsonModal)
        ),
    updateShowProductionListModal: (isShowProductionListModal) =>
        dispatch(updateShowProductionListModal(isShowProductionListModal)),
    updateShowPostProductionJsonModal: (isShowPostProductionJsonModal) =>
        dispatch(
            updateShowPostProductionJsonModal(isShowPostProductionJsonModal)
        ),
    updateShowAddToCartProductListModal: (isShowAddToCartProductListModal) =>
        dispatch(
            updateShowAddToCartProductListModal(isShowAddToCartProductListModal)
        ),
    updateListDataJson: (listData) => dispatch(updateListDataJson(listData)),
    // 以下為 api 相關
    postSaveStatusApi: (selectedCategoryIndex, selectedState) =>
        dispatch(postSaveStatusApi(selectedCategoryIndex, selectedState)),
    getSaveStatusApi: (savedCode) => dispatch(getSaveStatusApi(savedCode)),

    postSimpleProductApi: (selectedProduction) =>
        dispatch(postSimpleProductApi(selectedProduction)),
    postAddToCart: (productList) => dispatch(postAddToCartApi(productList)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
